<template>
  <div class="item">
    <div class="item_top">
      <div class="item_top_user">
        <div class="item_top_user_img pointer"><router-link :to="'/friend?id='+post.creator.id"><img :src="post.creator.avatar" /></router-link></div>
        <div class="item_top_userInfo">
          <div class="item_top_user_name">{{post.creator.nickname}}</div>
          <div class="item_top_user_time">{{timeToStr(post.createdDate)}}</div>
          <div class="item_top_user_ip">深圳</div>
        </div>
      </div>
      <div class="item_top_right" @click="operateFun()">
        <img src="@/assets/imgs/ellipsis.png" />
      </div>
    </div>
    <div class="item_content">
      <div class="msg" v-html="post.content"><span class="subject">#日常の風景#</span>今日Uちゃんが紹介する展覧会は、カナダから日本に帰国したばかりの森本啓太さん の個展で、15年ぶりの日本復帰となる初展です。森本啓太は古典絵画の技法や構図に興味を持ち、 バロック期の絵画のように完璧にコントロールされた光の表現 ...</div>
      <div class="oter">
        <div class="video" v-if="post.videoUrl">
          <img class="img" :src="post.images[0]" />
          <img class="play" src="@/assets/imgs/play.png" />
        </div>
        <div v-else class="picture" v-for="(imgs,index) in post.images">
          <img class="img" :src="imgs" />
        </div>
      </div>
    </div>
    <div class="item_btm">
      <div class="item_btm_item"><img src="@/assets/imgs/article_look.png" /> {{post.readNum}}</div>
      <div class="item_btm_item" @click="commentStateFun()"><img src="@/assets/imgs/comment.png" /> {{post.commentNum}}</div>
      <div class="item_btm_item" @click="likePostFun()"><img src="@/assets/imgs/article_like.png" v-if="!post.like"/><img src="@/assets/imgs/article_like_click.png" v-else/> {{post.likeNum}}</div>
    </div>
    <div class="item_operate" v-if="operateState">
      <div class="item_operate_item" @click="collectFun()">
        <div class="item_operate_item_img"><img v-if="post.favorite" src="@/assets/imgs/collect_icon_click.png" /><img v-else src="@/assets/imgs/collect.png" /></div>
      </div>
      <div class="item_operate_item">
        <div class="item_operate_item_img"><img src="@/assets/imgs/share.png" /></div>
        <div class="item_operate_item_msg">共有</div>
      </div>
      <div class="item_operate_item" @click="reportPopFun()">
        <div class="item_operate_item_img"><img src="@/assets/imgs/report.png" /></div>
        <div class="item_operate_item_msg">通報</div>
      </div>
      <div class="item_operate_share none"></div>
      <div class="float_left_operate_report_pop item_operate_report" v-if="reportPopState">
        <div class="float_left_operate_report_pop_title">
          ご意見?クレーム
          <div class="float_left_operate_report_pop_close" @click="reportPopFun()">
            <img src="@/assets/imgs/close.png" />
          </div>
        </div>
        <div class="float_left_operate_report_pop_content">
          <div class="float_left_operate_report_pop_content_item">
            <div class="float_left_operate_report_pop_content_title">
              理由をお選びください
              <div class="span">（復数選択可）</div>
            </div>
            <div class="content">
              <div class="content_btn" v-for="(item, index) in reportList" :key="index" v-bind:class="{on_click:on_click_id==item.type}" @click="onClickIdFun(item.type)">{{item.content}}</div>
            </div>
          </div>
          <div class="float_left_operate_report_pop_content_item">
            <div class="float_left_operate_report_pop_content_title">
              通報内容
            </div>
            <div class="textarea">
              <textarea placeholder="問題となる箇所をお教えください" v-model="reportContent"></textarea>
            </div>
          </div>
          <div class="float_left_operate_report_pop_content_item_btn" @click="onReportFun()">送信</div>
        </div>
      </div>
    </div>
    
    <div class="item_comment" v-if="commentState">
      <div class="body_center_left_comment" v-if="!isLogin">
        <div class="body_center_left_comment_speak">
          <span>先に<span class="body_center_left_comment_speak_span" @click="loginResFun()">ログインしてコメン</span>トしてください~</span>
        </div>
        <div class="body_center_left_comment_speak_btn">
          <div class="pointer" @click="loginResFun()">送信</div>
        </div>
        <div class="body_center_left_comment_hr"></div>
      </div>
      <div class="body_center_left_comment" v-else>
        <div class="body_center_left_comment_input">
          <div class="body_center_left_comment_user"><img :src="this.$store.state.userInfo.avatar"/></div>
          <div class="body_center_left_comment_user_input">
            <el-input v-model="comment" placeholder="说点什么吧!!"/>
          </div>
        </div>
        <div class="body_center_left_comment_speak_btn">
          <div class="pointer" @click="addComments()">送信</div>
        </div>
        <div class="body_center_left_comment_hr"></div>
      </div>
      <div class="body_center_left_comment_details">
        <comment :commentList="item" v-if="item" v-for="(item, index) in comments" :isArticle="false" :key="index"></comment>
      </div>
      <div class="body_center_left_comment_load" v-if="commentsState" @click="getCommentsList()">
        <div class="body_center_left_comment_load_span">すべてのコメントを表示</div>
        <div class="body_center_left_comment_load_img">
          <img src="@/assets/imgs/commentLoad.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { timeToStr,getReportList } from '@/assets/js/util'
import comment from '@/components/articleDetails/comment'
import * as json from '@/assets/js/json'
export default {
  props: {
    post: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  components: {
    comment
  },
  data () {
    return {
      operateState: false,
      reportPopState: false,
      commentState: false,
      on_click_id: 1,
      comments: null,
      commentsState: true,
      commentsPage: 0,
      isLogin: false,
      comment: null,
      reportList:getReportList(),
      reportContent: null
    }
  },
  created () {
    if(this.$store.state.token){
      this.isLogin = true
    }else{
      this.isLogin = false
    }
  },
  methods: {
    timeToStr (val) {
      return timeToStr(val)
    },
    operateFun(){
      if(this.operateState){
        this.operateState = false
      }else{
        this.getPost()
        this.operateState = true
      }
    },
    getPost(){
      let options = {
        postId : this.post.id
      }
      json.post('/api/member/post/watch',options).then(res => {
        this.post.favorite = res.data.data.post.favorite
      })
    },
    reportPopFun(){
      if(this.reportPopState){
        this.reportPopState = false
      }else{
        this.reportPopState = true
      }
    },
    commentStateFun(){
      if(this.commentState){
        this.commentState = false
      }else{
        this.commentsPage = 0
        this.getCommentsList()
        this.commentState = true
      }
    },
    getCommentsList(){
      this.commentsPage ++ 
      let options = {
        postId : this.post.id,
        size : 7,
        current : this.commentsPage
      }
      json.post('/api/member/post/comment/list',options).then((res) =>{
        if(res.data.data.page.records.length<7){
          this.commentsState = false
        }else{
          this.commentsState = true
        }
        let mergedArray= null
        if(this.commentsPage>1){
          mergedArray = this.comments.concat(res.data.data.page.records) 
        }else{
          mergedArray = res.data.data.page.records
        }
        this.comments = mergedArray
        this.comments.sort(function (a,b) {
          return b.createdDate - a.createdDate
        })
      })
    },
    addComments(){
      if(!this.$store.state.token){
        this.loginResFun()
        return false
      }
      if(!this.comment){
        this.$message.error('请输入评论内容')
        return false
      }
      const option = {
        postId : this.post.id,
        content : this.comment
      }
      json.post('/api/member/post/comment/add', option).then((res) =>{
        this.comment = null
        this.commentsPage = 0
        this.post.commentNum ++ 
        this.getCommentsList()
      })
    },
    onClickIdFun(id){
      this.on_click_id = id
    },
    onReportFun(){
      if(!this.$store.state.token){
        this.loginResFun()
        return false
      }
      let options={
        postId : this.post.id,
        state : 'UNRESOLVED',
        content : this.reportContent,
        type: this.on_click_id
      }
      json.post('/api/member/post/report/error/add',options).then((res) => {
        if(res.data.success){
          this.$notify({
            message: '举报成功',
            type: 'success'
          });
          this.on_click_id = 1
          this.reportContent=null
          this.reportPopFun()
          this.collectFun()
        }
      })
    },
    collectFun(){
      if(!this.$store.state.token){
        this.loginResFun()
        return false
      }
      this.$parent.collectFun(this.post.id,this.post.favorite)
      this.operateFun()
    },
    likePostFun(){
      let options = {
        postId : this.post.id,
      }
      if(this.post.like){
        json.post('/api/member/post/unlike',options).then((res) =>{
          if(res.data.success){
            this.post.like = false
            this.post.likeNum --
          }
        })
      }else{
        json.post('/api/member/post/like',options).then((res) =>{
          if(res.data.success){
            this.post.like = true
            this.post.likeNum ++
          }
        })
      }
    },
    likeFun(comment){
      let option = {
        commentId  : comment.id
      }
      if(comment.like){
        json.post('/api/member/post/comment/unlike',option).then(res =>{
          if(res.data.success){
            this.commentsPage = 0
            this.getCommentsList()
          }
        })
      }else{
        json.post('/api/member/post/comment/like',option).then(res =>{
          if(res.data.success){
            this.commentsPage = 0
            this.getCommentsList()
          }
        })
      }
    },
    loginResFun(){
      this.$parent.loginResFun()
    }
  }
}
</script>

<style src="@/pages/index/find/index.css" scoped>
</style>
<style src="@/components/articleDetails/index.css" scoped>
</style>